import React, { useState } from "react";
import { clsx } from "clsx";
import { FaRegClipboard } from "react-icons/fa";
import toast from "react-hot-toast";

function KeyDisplay({ label, value, color, isPrivate = false }) {
  const [show, setShow] = useState(!isPrivate);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success(`${label} copied!`);
  };

  return (
    <div className="space-y-1 group">
      <div className="flex items-center justify-between text-xs font-semibold uppercase tracking-wider text-text-muted">
        <span>{label}</span>
        {isPrivate && (
          <button
            onClick={() => setShow(!show)}
            className="text-[10px] hover:text-white transition-colors"
          >
            {show ? "HIDE" : "SHOW"}
          </button>
        )}
      </div>
      <div className="flex items-center gap-2">
        <div
          className={clsx(
            "flex-1 bg-surface border border-white/5 rounded-lg px-3 py-2 text-sm font-mono truncate",
            color,
            !show && "blur-[4px] select-none"
          )}
        >
          {value || "No Data"}
        </div>
        <button
          onClick={() => handleCopy(value)}
          className="p-2.5 bg-white/5 border border-white/10 rounded-lg text-text-muted hover:text-white hover:bg-white/10 transition-all active:scale-95"
          title={`Copy ${label}`}
        >
          <FaRegClipboard size={14} />
        </button>
      </div>
    </div>
  );
}

export default KeyDisplay;
